import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import api from "../../axiosConfig";

const AverageDailySales = () => {
  const [series, setSeries] = useState([{ name: "Peticiones", data: [] }]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  // Total acumulado para mostrar arriba de la gráfica
  const totalVisitas = useMemo(() => {
    const arr = series?.[0]?.data || [];
    return arr.reduce((acc, n) => acc + (Number(n) || 0), 0);
  }, [series]);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      setLoading(true);
      setErr(null);
      try {
        const res = await api.get("/dashboard/admin/bar");
        // Se espera { data: [ { dia, nombreDia|nombre_dia, total }, ... ] }
        const list = Array.isArray(res?.data?.data) ? res.data.data : [];

        const normalized = list
          .map((it) => ({
            dia: it.dia ?? it.Dia ?? it.fecha ?? it.Fecha,
            nombreDia: it.nombreDia ?? it.nombre_dia ?? it.NombreDia ?? it.nombre,
            total: Number(it.total ?? it.Total ?? 0),
          }))
          .filter((x) => x.dia)
          .sort((a, b) => new Date(a.dia).getTime() - new Date(b.dia).getTime());

        const cats = normalized.map((x) => x.nombreDia || x.dia);
        const data = normalized.map((x) => x.total);

        if (mounted) {
          setCategories(cats);
          setSeries([{ name: "Peticiones", data }]);
        }
      } catch (e) {
        if (mounted) setErr("No se pudo cargar la serie.");
        console.error("AverageDailySales error:", e);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  const barChartOptionsOne = {
    chart: { type: "bar", height: 200, toolbar: { show: false } },
    plotOptions: {
      bar: {
        borderRadius: 6,
        horizontal: false,
        columnWidth: "40%",
        endingShape: "rounded",
      },
    },
    dataLabels: { enabled: false },
    fill: {
      type: "gradient",
      colors: ["#dae5ff"],
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        gradientToColors: ["#dae5ff"],
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    grid: {
      show: false,
      borderColor: "#D1D5DB",
      strokeDashArray: 4,
      position: "back",
      padding: { top: -10, right: -10, bottom: -10, left: -10 },
    },
    xaxis: {
      type: "category",
      categories,
      labels: { rotate: -15, trim: true },
    },
    yaxis: { show: false },
    tooltip: {
      y: { formatter: (val) => `${val} peticiones` },
    },
    noData: {
      text: loading ? "Cargando…" : err ? "Sin datos" : "No hay datos",
    },
  };

  return (
    <div className="col-xxl-4 col-xl-6">
      <div className="card h-100">
        <div className="card-body p-24">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
            <h6 className="mb-2 fw-bold text-lg mb-0">Peticiones</h6>
          </div>

          <h6 className="text-center my-20">
            {loading ? "Cargando…" : `${totalVisitas.toLocaleString()} Peticiones`}
          </h6>

          {err && <div className="alert alert-danger py-8 px-12 mb-12">{err}</div>}

          <div id="barChart" className="barChart">
            <ReactApexChart
              options={barChartOptionsOne}
              series={series}
              type="bar"
              height={220}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AverageDailySales;